export const SPLASH_LOTTIE_TEST_IDS = {
    CONTAINER: "SPLASH_LOTTIE_CONTAINER",
    LOTTIE_ANIMATION: "SPLASH_LOTTIE_ANIMATION",
};

